<script lang="ts">
export const elContainerTemplateVariants = ['table', 'drawer'] as const;
export type ElContainerTemplateVariant = (typeof elContainerTemplateVariants)[number];
</script>

<script setup lang="ts">
import { ref } from 'vue';
import { ElDrawer } from '.';
import ElTabGroup from './ElTabGroup.vue';

const props = defineProps<{
  title: string;
  description?: string;
  tabs?: InstanceType<typeof ElTabGroup>['$props'];
  selectedTab?: string;
  variant: { name: 'table' } | { name: 'drawer'; drawerTitle: string };
}>();

const emit = defineEmits<{
  (event: 'onTabChange', tab: string): void;
}>();

const selectedTab = ref<string>(props.selectedTab || '');
</script>

<template>
  <div class="rounded-3xl border shadow-md border-neutral-surface bg-neutral-surface overflow-hidden">
    <div class="px-4 py-8 flex justify-between items-center text-neutral-darker">
      <div class="flex flex-col gap-5">
        <h1 class="text-3xl font-semibold">{{ title }}</h1>
        <p v-if="description?.length" class="text-sm">{{ description }}</p>
      </div>
      <div class="flex items-center gap-2">
        <div class="min-w-44">
          <slot name="input-select"> </slot>
        </div>
        <slot name="secondary-button"></slot>
        <slot name="primary-button"></slot>

        <slot name="icon-button"></slot>
      </div>
    </div>
    <div class="px-4 pb-6">
      <ElTabGroup v-if="tabs" v-bind="tabs" v-model="selectedTab" @update:model-value="tab => emit('onTabChange', tab)" />
    </div>
    <div>
      <slot v-if="variant.name === 'table'" name="table"> </slot>
      <div v-if="variant.name === 'drawer'" class="flex">
        <div class="min-w-72">
          <ElDrawer :headline="variant.drawerTitle">
            <slot name="drawer-content"> </slot>
          </ElDrawer>
        </div>
        <div class="flex-1 w-full">
          <slot name="content-slot"> </slot>
        </div>
      </div>
    </div>
  </div>
</template>
